import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' }
  ];

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 text-white hover:text-orange-400 transition-colors">
        <Globe size={18} />
        <span className="text-base font-semibold uppercase">{language}</span>
      </button>
      
      {/* Dropdown */}
      <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 min-w-[150px]">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`w-full text-left px-6 py-3 hover:bg-orange-50 transition-colors flex items-center gap-3 first:rounded-t-lg last:rounded-b-lg ${
              language === lang.code ? 'bg-orange-100 text-orange-600 font-semibold' : 'text-gray-700'
            }`}
          >
            <span className="text-2xl">{lang.flag}</span>
            <span>{lang.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;